import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { SnackBarComponent } from '../shared/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackBarComponentRef: any;

  constructor(
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef
  ) {}

  show(
    title: string='',
    message: string='',
    type: 'success' | 'error' = 'success',
    duration?: number
  ): void {
    const defaultDuration = type === 'error' ? 6000 : 3000;
    const finalDuration = duration !== undefined ? duration : defaultDuration;

    const factory =
      this.componentFactoryResolver.resolveComponentFactory(SnackBarComponent);
    this.snackBarComponentRef = factory.create(this.injector);

    this.appRef.attachView(this.snackBarComponentRef.hostView);

    this.snackBarComponentRef.instance.showMessage(
      title,
      message,
      type,
      finalDuration
    );

    const domElem = (this.snackBarComponentRef.hostView as any).rootNodes[0];
    document.body.appendChild(domElem);
  }
}
